import { useState } from "react";
import { Megaphone, X, ExternalLink } from "lucide-react";
import { api } from "../lib/api";
import { useGet } from "../lib/hooks";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function AnnouncementBar() {
  const [list, reload] = useGet("/announcements/active");
  const [open, setOpen] = useState(null);
  if (!list?.length) return null;
  const close = async (a) => { await api.post(`/announcements/${a.id}/dismiss`); reload(); };
  return (
    <div className="-mt-2 mb-5 space-y-2" data-testid="announcement-bar">
      {list.map((a) => (
        <div key={a.id} className="flex items-center gap-3 rounded-md px-4 py-2 shadow-sm" style={{ background: "linear-gradient(90deg,#C2A462,#d8bf85)" }} data-testid={`announcement-${a.id}`}>
          <Megaphone className="h-4 w-4 shrink-0 text-[#0b1428]" />
          <div className="min-w-0 flex-1 truncate text-[13px] text-[#0b1428]"><b>{a.title}</b> {a.message}</div>
          {(a.read_more_text || a.read_more_url) && <button onClick={() => setOpen(a)} className="shrink-0 rounded-full border border-[#0b1428]/40 px-3 py-0.5 text-[12px] font-semibold text-[#0b1428] hover:bg-[#0b1428]/10" data-testid={`announcement-read-more-${a.id}`}>Read more</button>}
          <button onClick={() => close(a)} className="shrink-0 text-[#0b1428]/70 hover:text-[#0b1428]" aria-label="Close" data-testid={`announcement-close-${a.id}`}><X className="h-4 w-4" /></button>
        </div>
      ))}
      {open && (
        <Dialog open onOpenChange={() => setOpen(null)}>
          <DialogContent data-testid="announcement-dialog">
            <DialogHeader><DialogTitle>{open.title}</DialogTitle></DialogHeader>
            <p className="text-sm text-slate-300 whitespace-pre-line">{open.message}</p>
            {open.read_more_text && <p className="text-sm text-slate-300 whitespace-pre-line">{open.read_more_text}</p>}
            {open.read_more_url && <a href={open.read_more_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-sm text-[#C2A462] hover:underline" data-testid="announcement-link">Open link <ExternalLink className="h-3.5 w-3.5" /></a>}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
